import { Column } from "@stenajs-webui/core";
import { Banner, FlatButton } from "@stenajs-webui/elements";

export const renderError = (
  localError: Error | undefined,
  clearLocalError: () => void
) => {
  return (
    <Column>
      <Banner
        variant={"error"}
        headerText={"Could not calculate price"}
        text={localError?.message}
        contentRight={
          <FlatButton label={"Clear error"} onClick={() => clearLocalError()} />
        }
      />
    </Column>
  );
};
